module.exports = __webpack_public_path__ + "img/1.7bf7b3d1.jpg";